import React, { useState } from "react";
import _ from "lodash";
import { useSelector } from "react-redux";
import moment from "moment";
import { useNavigate } from "react-router-dom";

const SearchGoodsList = () => {

  /** redux store useDispatch & useSelector ------------------------------ **/
  const navigate = useNavigate()
  const { signoutModelOpenFlag } = useSelector((state) => state.auth);
  const { searchResultData } = useSelector((state) => state.search);

  /** hooks useState ----------------------------------------------------- **/
  const [activeRecordIndex, setActiveRecordIndex] = useState(null);

  /** Variable declarations ----------------------------------------------------- **/
  let userDetails = JSON.parse(localStorage.getItem("userDetails"))

  /** handler functions--------------------------------------------------- **/

  /** Function to handle individual row click ----------------------------- **/
  const handleRowClick = (index) => {
    if (index !== activeRecordIndex) {
      setActiveRecordIndex(index);
    } else {
      setActiveRecordIndex(null);
    }
  };

  return (
    <>
      <div
        className={`p-2 ${signoutModelOpenFlag === true ? "add-overlay-for-depot-dropdown" : ""
          } main-goods-in-tab-div d-flex flex-column ms-3 me-3`}
        style={{ width: "100%" }}
      >
        <div className="p-3 ps-2">
          <span className="search-tab-text-style">
            Showing {searchResultData.length} results, Select one to view
            details.
          </span>
        </div>
        <div className="table-responsive main-goods-in-tab-div d-flex flex-column" style={{ marginBottom: 75 }}>
          <table
            className="table goodsin-table table-borderless"
            style={{ position: "relative", zIndex: 9999 }}
          >
            <thead>
              <tr>
                <th
                  scope="col"
                  style={{ minWidth: 200 }}
                  className="text-uppercase text-primary"
                >
                  client
                </th>
                <th
                  scope="col"
                  style={{ minWidth: 200 }}
                  className="text-uppercase text-primary"
                >
                  project
                </th>
                <th scope="col" style={{ minWidth: 150 }} className="text-uppercase text-primary">
                  ITEM
                </th>
                <th
                  scope="col"
                  style={{ minWidth: 80 }}
                  className="text-uppercase text-primary"
                >
                  COND.
                </th>
                {(userDetails?.roles == "SuperAdmin" || userDetails?.roles == "Admin") && (
                  <th
                    scope="col"
                    style={{ minWidth: 150 }}
                    className="text-uppercase text-primary"
                  >
                    DEPOT
                  </th>
                )}
                <th scope="col" className="text-uppercase text-primary">
                  UNITS
                </th>
                <th
                  scope="col"
                  style={{ minWidth: 80 }}
                  className="text-uppercase text-primary"
                >
                  INT. (m2)
                </th>
                <th
                  scope="col"
                  style={{ minWidth: 80 }}
                  className="text-uppercase text-primary"
                >
                  EXT. (m2)
                </th>
                <th scope="col" style={{ minWidth: 200 }} className="text-uppercase text-primary">
                  PROJECT MANAGER
                </th>
                <th style={{ minWidth: 150 }} scope="col" className="text-uppercase text-primary">
                  CONTACT NUMBER
                </th>
              </tr>
            </thead>
            <tbody className="goods-table-body">
              {searchResultData && searchResultData[0] ? (
                searchResultData.map((item, index) => {
                  const countdispatchUnits = parseInt(item?.quantityReceived) - parseInt(_.sumBy(item?.dispatchItem, (d) => d.dispatchUnits))
                  return (
                    <React.Fragment key={index}>
                      <tr
                        key={index}
                        className={`goodsin-tr ${activeRecordIndex === index ? "row-border" : ""
                          }`}
                        onClick={() => handleRowClick(index)}
                      >
                        <td>{item.client}</td>
                        <td>{item.project}</td>
                        <td>{item.itemNumber}</td>
                        <td>{item.itemCondition}</td>
                        {(userDetails?.roles == "SuperAdmin" || userDetails?.roles == "Admin") && (
                          <td>{item.depot}</td>
                        )}
                        <td>{countdispatchUnits}</td>
                        <td>{item.interiorSpaceOccupied}</td>
                        <td>{item.exteriorSpaceOccupied}</td>
                        <td>{item.projectManager}</td>
                        <td>{item.contactNumber}</td>
                      </tr>
                      {activeRecordIndex === index && (
                        <div className="main-class-for-view-record-content">
                          <div className="row mb-5">
                            <div
                              className="col-md-6"
                              style={{ borderRight: "1px solid #BEBFC2" }}
                            >
                              <div className="row">
                                <span className="search-header-font-change">
                                  GOODS IN {1} RECORDS
                                </span>
                              </div>
                              <div className="row" style={{ paddingTop: 10 }}>
                                <div className="col-md-4">
                                  <span className="searchtab-view-record-header text-uppercase">
                                    {moment(item?.goodsInDate).format(
                                      "DD-MMM-YYYY"
                                    ) || ""}
                                  </span>
                                </div>
                                <div className="col-md-4">
                                  <span className="searchtab-view-record-header">
                                    {item.quantityReceived} units
                                  </span>
                                </div>
                                <div className="col-md-4" onClick={() => {
                                  navigate(`/app/goodsin/detail/${item?.shipmentId}`)
                                }}>
                                  <span className="searchtab-view-record-header" style={{ color: "#0045d9", cursor: "pointer" }}>
                                    {item.shipmentReferenceNumber}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="row">
                                <span className="search-header-font-change">
                                  DISPATCHES {item?.dispatchItem?.length || 0}{" "}
                                  RECORDS
                                </span>
                              </div>
                              {item?.dispatchItem?.length > 0 &&
                                item?.dispatchItem?.map((d, index) => {
                                  return (
                                    <div
                                      key={index}
                                      className="row"
                                      style={{ paddingTop: 10 }}
                                    >
                                      <div className="col-md-4">
                                        <span className="searchtab-view-record-header">
                                          {moment(d?.dispatchDate).format(
                                            "DD-MMM-YYYY"
                                          ) || ""}
                                        </span>
                                      </div>
                                      <div className="col-md-4">
                                        <span className="searchtab-view-record-header">
                                          {d.dispatchUnits} units
                                        </span>
                                      </div>
                                      <div className="col-md-4"
                                        onClick={() => {
                                          navigate(`/app/dispatchorders/detail/${d?.deliveryOrderId}`)
                                        }}
                                      >
                                        <span className="searchtab-view-record-header" style={{ color: "#0045d9", cursor: "pointer" }}>
                                          {d.deliveryOrderNo}
                                        </span>
                                      </div>
                                    </div>
                                  );
                                })}
                            </div>
                          </div>
                        </div>
                      )}
                    </React.Fragment>
                  );
                })
              ) : (
                <tr>
                  <td
                    className="not-found-txt"
                    colSpan="11"
                    style={{
                      textAlign: "center",
                      fontFamily: "Montserrat-medium",
                    }}
                  >
                    No Records Found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};
export default SearchGoodsList;
